import type { FC } from 'react';
import { lazy, memo, Suspense } from 'react';
import LoadingPage from '@components/LoadingPage';

const ComponentLoad = lazy(async () => await import('./component'));

const ArticlePage: FC = () => (
  <Suspense fallback={<LoadingPage />}>
    <ComponentLoad />
  </Suspense>
);

export default memo(ArticlePage);
